// extracted by mini-css-extract-plugin
module.exports = {"Intro":"Intro_Intro__3fCU2","Text":"Intro_Text__3Y-9d","IntroBox":"Intro_IntroBox__2eGjF","IntroBoxWrapper":"Intro_IntroBoxWrapper__3k5py"};